import React, { useEffect, useState /* , useMemo */ } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  // Rating,
  Button,
  IconButton,
  Tooltip,
  Divider,
  Typography,
  Box,
  Stack,
} from '@mui/material';
// import StarBorder from '@mui/icons-material/StarBorder';
// import StarIcon from '@mui/icons-material/Star';
import CallIcon from '@mui/icons-material/Call';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { useAtomValue, useSetAtom } from 'jotai';
import {
  productsAtom,
  maxDistanceAtom,
  searchValuesAtom,
  outcomesAtom,
  practiceProductAtom,
  subsectionsAtom,
} from '../../Atoms';
import EmployerSearchBox from '../Inputs/EmployerSearchBox';
import OccupationSelect from '../Inputs/OccupationSelect';
import MultipleChipSelect from '../Inputs/MultipleChipSelect';
import FetchAutoComplete from '../Inputs/FetchAutoComplete';
import CheckboxStack from '../Inputs/CheckboxStack';
import { /* RATING, */ MIN_DISTANCE } from '../../Utils/constants/general';
import KmDistanceSelector from '../Inputs/KmDistanceSelector';
import { applyCallFilter } from '../../Helpers/Filters/constants';
import RangeNumbersField from '../Inputs/RangeNumbersField';
// import StyledSwitch from '../Inputs/StyledSwitch';

/* const checkboxes = RATING.map((i) => ({
  label: (
    <Rating
      name={`rating${i}`}
      value={i}
      size="large"
      readOnly
      emptyIcon={<StarBorder fontSize="inherit" color="primary" />}
      icon={<StarIcon fontSize="inherit" color="primary" />}
    />
  ),
  value: i,
})); */

/* const applyDefaultRating = (defaultRatingAr = RATING) => {
  const dRating = [null, null, null, null, null, null]; //rating empty
  for (let i = 0; i < defaultRatingAr?.length; i += 1) {
    dRating[parseInt(defaultRatingAr[i], 10)] = defaultRatingAr[i].toString(); //components expects a string
  }
  return dRating;
};
 */
const FiltersSelection = function FiltersSelection({
  // defaultRating = [],
  showWaveFilters = false,
  currentSection = 'CUSTOMERS',
  defaultFilters = {},
  closeMenu,
}) {
  const intl = useIntl();
  const products = useAtomValue(productsAtom);
  const maxDistance = useAtomValue(maxDistanceAtom);
  const setSearchValues = useSetAtom(searchValuesAtom);
  const sectionOutcomes = useAtomValue(outcomesAtom); //all the available call outcomes for this section
  const practiceProducts = useAtomValue(practiceProductAtom);
  const subsectionsOptions = useAtomValue(subsectionsAtom);
  const normalizeSelectedValues = (value) =>
    Array.isArray(value) ? value : value ? [value] : [];
  const [practiceProduct, setPracticeProduct] = useState(
    defaultFilters?.practiceProduct
  );
  const [installments, setInstallments] = useState({
    value: [],
    exclude: false,
  });
  const [subsections, setSubsections] = useState([]);
  // const [rating, setRating] = useState([]);
  const [employer, setEmployer] = useState(defaultFilters?.employeer);
  const [product, setProduct] = useState(
    normalizeSelectedValues(defaultFilters?.lastProductName)
  );
  const [outcomes, setOutcomes] = useState(null);
  const [occupation, setOccupation] = useState(defaultFilters?.occupation);
  const [currentWaveOutcomes, setCurrentWaveOutcomes] = useState();
  const [selectedCallFilter, setSelectedCallFilter] = useState(null);
  const [distance, setDistance] = useState(
    defaultFilters?.distanceKm ?? [0, Math.ceil(maxDistance)]
  );
  /*   const [inCurrentWave, setInCurrentWave] = useState(
    defaultFilters?.inCurrentWave || false
  ); */
  /*
  const checkedRating = useMemo(
    () => applyDefaultRating(defaultRating),
    [defaultRating]
  ); */

  useEffect(() => {
    if (defaultFilters) {
      setOutcomes(
        defaultFilters?.lastCallOutcome?.map((value) =>
          sectionOutcomes?.find(({ id }) => id === value)?.name?.toUpperCase()
        )
      );
      setDistance(defaultFilters?.distanceKm ?? [0, Math.ceil(maxDistance)]);
      setCurrentWaveOutcomes(
        currentSection !== 'CUSTOMERS' &&
          currentSection !== 'BIRTHDAYS' &&
          defaultFilters?.calledInCurrentPeriod
          ? [0]
          : [null]
      );
      setEmployer(defaultFilters?.employeer);
      setOccupation(defaultFilters?.occupation);
      setProduct(normalizeSelectedValues(defaultFilters?.lastProductName));
      setSelectedCallFilter(
        showWaveFilters
          ? defaultFilters?.lastCallInCurrentMonth
          : defaultFilters?.called
      );
      setInstallments({
        rawValue: defaultFilters?.paidInstallments?.rawValue,
        value: defaultFilters?.paidInstallments?.value,
        exclude: defaultFilters?.paidInstallments?.operator === '!in',
      });
      setPracticeProduct(defaultFilters?.practiceProduct);
      // setInCurrentWave(defaultFilters?.inCurrentWave);
      setSubsections(defaultFilters?.subsectionId);
    }
  }, [defaultFilters]);

  /*   useEffect(() => {
    setRating(checkedRating);
  }, [checkedRating]); */

  const handleChangeEmployer = (e) => {
    setEmployer(e.target.value);
  };

  /*   const handleChangeRating = (newRating) => {
    setRating(newRating);
  }; */

  const selectCallFilter = (value) => {
    setSelectedCallFilter(value);
  };

  const handleChangeCurrentWaveOutcomes = (newValue) => {
    setCurrentWaveOutcomes(newValue);
  };

  const handleOutcomesChange = (newValues) => {
    if (!Array.isArray(newValues) || newValues.length === 0) setOutcomes(null);
    else {
      setOutcomes(newValues);
    }
  };

  const handlePracticeProductChange = (value) => {
    if (!Array.isArray(value) || value.length === 0) setPracticeProduct(null);
    else {
      setPracticeProduct(value);
    }
  };
  const handleSubsectionsChange = (value) => {
    if (!Array.isArray(value) || value.length === 0) setSubsections(null);
    else {
      setSubsections(value);
    }
  };

  const handleOccupationChange = (value) => {
    if (!Array.isArray(value) || value.length === 0) setOccupation(null);
    else {
      setOccupation(value);
    }
  };

  const handleProductChange = (value) => {
    if (!Array.isArray(value) || value.length === 0) setProduct(null);
    else {
      setProduct(value);
    }
  };

  const handleChangeDistance = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    if (activeThumb === 0) {
      setDistance([
        Math.min(newValue[0], distance[1] - MIN_DISTANCE),
        distance[1],
      ]); //maintains min distance between two values
    } else {
      setDistance([
        distance[0],
        Math.max(newValue[1], distance[0] + MIN_DISTANCE),
      ]);
    }
  };

  const handleChangeInstallments = (newValue) => {
    setInstallments(newValue);
  };

  /*   const handleChangeInCurrentWave = (event) => {
    setInCurrentWave(event.target.checked);
  };
 */
  const handleFilterChange = () => {
    const callFilter = applyCallFilter(!showWaveFilters, selectedCallFilter);
    setSearchValues((prev) => ({
      ...prev,
      // ratingValue: rating.filter((el) => el !== null).reverse(), //ES: [5,3,1,0]
      ...callFilter,
      occupation,
      lastProductName: product?.length > 0 ? product : null,
      employeer: employer,
      distanceKm:
        distance[0] === 0 && distance[1] === Math.ceil(maxDistance)
          ? null
          : distance,
      lastCallOutcome: outcomes
        ? outcomes?.map(
            (o) =>
              sectionOutcomes.find(
                ({ name }) => name.toUpperCase() === o.toUpperCase()
              )?.id
          )
        : null,
      calledInCurrentPeriod:
        currentWaveOutcomes?.length > 0 && currentWaveOutcomes[0] !== null
          ? true
          : null,
      paidInstallments:
        installments?.range?.length > 0
          ? {
              rawValue: installments?.rawValue,
              value: installments?.range,
              operator: installments?.exclude ? '!in' : 'in',
            }
          : null,
      practiceProduct,
      // inCurrentWave: inCurrentWave ? true : null,
      subsectionId: subsections,
    }));
    closeMenu();
  };

  return (
    <>
      {/*  {!showWaveFilters && (
        <>
          <Box display="flex" justifyContent="center" padding="8px">
            <StyledSwitch
              label={intl.messages.ONLY_CURRENT_WAVE}
              checked={inCurrentWave}
              onChange={handleChangeInCurrentWave}
            />
          </Box>
          <Divider variant="middle" />
        </>
      )} */}
      <Box
        sx={{
          display: 'flex',
          width: '35vw',
          gap: '10%',
          padding: '8px 16px',
        }}
      >
        <Stack
          spacing={1}
          direction="column"
          sx={{
            width: '50%',
          }}
        >
          <div>
            <MultipleChipSelect
              label={intl.messages.LAST_CALL_OUTCOME}
              onChange={handleOutcomesChange}
              values={outcomes || []}
              options={sectionOutcomes?.map(({ name }) => name?.toUpperCase())}
            />

            <CheckboxStack
              data={[
                {
                  label: intl.messages.CURRENT_WAVE_OUTCOMES,
                  value: 0,
                  disabled:
                    !outcomes ||
                    outcomes?.length < 1 ||
                    currentSection === 'CUSTOMERS' ||
                    currentSection === 'BIRTHDAYS',
                },
              ]}
              defaultCheckedAr={currentWaveOutcomes}
              handleChange={handleChangeCurrentWaveOutcomes}
            />
          </div>
          <OccupationSelect
            onChange={handleOccupationChange}
            values={occupation || []}
          />
          <Box sx={{ marginTop: '28px!important' }}>
            <FetchAutoComplete
              id="offer-type-autocomplete"
              label={intl.messages.OFFER_TYPE}
              placeholder={`${intl.messages.INSERT} ${intl.messages.OFFER_TYPE}`}
              multiple
              selectedValue={product || []}
              onChangeSelectedValue={(event, newValue) =>
                handleProductChange(newValue)
              }
              staticOptions={products || []}
              noCustomValue
              getOptionLabel={(option) => option}
            />
          </Box>
        </Stack>

        <Stack
          spacing={1}
          direction="column"
          sx={{
            width: '50%',
          }}
        >
          {showWaveFilters && currentSection !== 'CUSTOMERS' && (
            <MultipleChipSelect
              label={intl.messages.SUBSECTIONS}
              onChange={handleSubsectionsChange}
              values={subsections || []}
              options={subsectionsOptions.map(({ id, name }) => ({
                value: id,
                label: name,
              }))}
            />
          )}
          <RangeNumbersField
            name="paid_Installments"
            rangeValue={installments}
            onChangeRangeValue={handleChangeInstallments}
            defaultValue={{
              ...defaultFilters?.paidInstallments,
              exclude: defaultFilters?.paidInstallments?.operator === '!in',
            }}
          />
          <MultipleChipSelect
            label={intl.messages.DESCRIPTION_PRACTICE_PRODUCT}
            onChange={handlePracticeProductChange}
            values={practiceProduct || []}
            options={practiceProducts || []}
          />
          <EmployerSearchBox value={employer} onChange={handleChangeEmployer} />
          {/*   <CheckboxStack
            styles={{
              stackStyle: { gap: '6px' },
              formGroupStyle: { gap: '6px' },
            }}
            noEmptyValues
            defaultCheckedAr={checkedRating}
            data={checkboxes}
            label={intl.messages.RATING}
            handleChange={handleChangeRating}
          /> */}
        </Stack>
      </Box>
      {maxDistance ? (
        <>
          <Divider variant="middle" />
          <KmDistanceSelector
            value={distance}
            onChange={handleChangeDistance}
            max={Math.ceil(maxDistance)}
          />
        </>
      ) : null}
      <Divider variant="middle" />
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography sx={{ fontSize: '14px' }}>
          {showWaveFilters
            ? intl.messages.MONTH_CALLED_INDICATOR
            : intl.messages.DAY_CALLED_INDICATOR}
          :
        </Typography>
        <Tooltip title={intl.messages.SHOW_CUSTOMERS_ALREADY_CALLED}>
          <IconButton size="large" onClick={() => selectCallFilter(1)}>
            <CallIcon
              color={selectedCallFilter === 1 ? 'success' : 'disabled'}
            />
          </IconButton>
        </Tooltip>
        <Tooltip title={intl.messages.SHOW_CUSTOMERS_NOT_CALLED}>
          <IconButton size="large" onClick={() => selectCallFilter(0)}>
            <PhoneDisabledIcon
              color={selectedCallFilter === 0 ? 'error' : 'disabled'}
            />
          </IconButton>
        </Tooltip>
        <Tooltip title={intl.messages.SHOW_ALL}>
          <IconButton size="large" onClick={() => selectCallFilter(null)}>
            <FilterAltOffIcon
              color={selectedCallFilter === null ? 'primary' : 'disabled'}
            />
          </IconButton>
        </Tooltip>
      </div>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          position: 'sticky',
          bottom: 0,
        }}
      >
        <Button
          id="confirm-filters-btn"
          size="large"
          onClick={handleFilterChange}
        >
          {intl.messages.CONFIRM}
        </Button>
      </Box>
    </>
  );
};

FiltersSelection.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  // defaultRating: PropTypes.array,
  showWaveFilters: PropTypes.bool,
  currentSection: PropTypes.string,
  defaultFilters: PropTypes.object,
};

export default FiltersSelection;
